import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { FormGroup, Button, Col, Row, FormControl, Checkbox, ControlLabel} from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import debounce from "lodash/debounce";
import UserService from "../../../services/UserService";
import ProjectsService from "../../../services/ProjectsService";
import SearchService from "../../../services/SearchService";
import AdminService from "../../../services/AdminService";
import TasksService from "../../../services/TasksService";
import HandleError from "../../../services/HandleError";
import LoaderInline from "../../helpers/LoaderInline";
import InlineError from "../../messages/InlineError";
import Materialicon from "../../helpers/Materialicon";
import LoadingSVG from "../../helpers/LoadingSVG";
import NewTaskModal from "../../modals/NewTaskModal";
import { dataToSelectOption } from "../../helpers/HelperFunctions";

class TaskEditForm extends Component {

    state = {
    	saveTaskLoading: false,
    	showNewTaskModal: false,
    	isUpdatingTask: false,
    	isLoadingTask: true,
    	isLoadingStatuses: true,
    	isLoadingAreas: false,
    	selectedEmployee: null,
    	newTaskSelectedEmployee: null,
    	selectedParentTask: "",
    	selectedProject: null,
    	selectedArea: null,
    	newTaskParent: null,
    	projects: [],
    	areas: [],
    	statuses: [],
    	formData:{},
    	newTaskFormData: {},
    	newTaskErrors: {},
    	errors: {},
    }

    componentDidMount = () => { this.getTask(); this.getTaskStatuses(); }

    onChange = (e, formData) => {
    	this.setState({
    		...this.state,
    		[formData]: {...this.state[formData], [e.target.name]: e.target.value }});
    }

	onSelectChange = (option, name, selected, formData) => {
    	if (option !== null) {
    		this.setState({ [selected]:option, [formData]: { ...this.state[formData], [name]: option.value || option.id || "" }});
    	}
    	else {
    		this.setState({ [selected]: null, [formData]: { ...this.state[formData], [name]: null }});
    	}
	};
	
    onProjectsSelectChange = (option, name) => {
    	const projectAreasService = new ProjectsService(this,`/${option.value}?user_task=true`);
    	if(option !== null) {
    		this.setState({ formData: {...this.state.formData, [name]: option.value || "" }, isLoadingAreas: true }, );
    		projectAreasService.index().then((res) => {
    			this.setState({
    				...this.state,
    				isLoadingAreas: false,
    				areas: res.data.areas,
    				formData:{...this.state.formData, area_id: null }
    			});
    		}).catch((err) => {
    			this.setState({isLoadingAreas: false});
    			HandleError(err, this);
    		});
    	}
    }
	
	onEmployeeSelectChange = (employee, selected, formData) => {
		if(employee !== null) {
			this.setState({[selected]: dataToSelectOption(employee.id,"id",employee.full_name,"full_name"), [formData]:{...this.state[formData], assigned_to: employee.id }});
		}
	}
	
	onParentSelectChange = (parentTask) => {
		if(parentTask !== null) {
			this.setState({selectedParentTask:parentTask, formData: {...this.state.formData, parent_id: parentTask.id} });
		}
	}

	onCheckboxChange = (e, formData) => {
    	this.setState({ [formData]: {...this.state[formData], [e.target.name]: e.target.checked }});
	}
	
	onSubmit = (e) => {
		e.preventDefault();
		this.setState({isUpdatingTask: true});
		const {taskId} = this.props.match.params;	
		this.tasksService.update(taskId, this.state.formData).then((res) => {
			this.setState({ isUpdatingTask: false });	
			NotificationManager.success("Task updated.","Success!");					
			this.props.history.goBack();	 
		}).catch((err) => {
			this.setState({ isUpdatingTask: false });						
			HandleError(err, this);
		});
	}

	onTaskCreateSubmit = () => {
		this.setState({saveTaskLoading: true, newTaskErrors: {}});
		this.tasksService.store(this.state.newTaskFormData).then((res) => {
			this.setState({ saveTaskLoading: false, showNewTaskModal:false });	
			NotificationManager.success("Task created.","Success!");
			this.props.history.goBack();				 
		}).catch((err) => {
			this.setState({ saveTaskLoading: false });			
			if(err.response.status === 422) {
				const newTaskErrors = {};
				Object.keys(err.response.data).forEach((key) => {
					newTaskErrors[key] = err.response.data[key][0];
				});
				this.setState({...this.state, newTaskErrors });
				return;
			}			
			HandleError(err, this);
		});
	}

    getTaskStatuses = () => {
    	const editTaskProjectService = new ProjectsService(this);
    	editTaskProjectService.index(0,"statuses=true").then((res) => {
    		this.setState({
    			...this.state, 
    			isLoadingStatuses: false, 
    			statuses: res.data.statuses ? res.data.statuses.map((status)=>({ value: status.id, label: status.name })) : []
    		});           
    	}).catch((err) => {
    		this.setState({ isLoadingStatuses: false });            
    		HandleError(err,this);
    	});
    }


    /**
     * Fetch task that user wants to edit.
     */
    getTask = () => {
    	const { taskId } = this.props.match.params;
    	// get task formdata
    	this.tasksService.show(taskId).then((res) => {
    		const task = res.data.task;
    		if(task) {
    			this.setState({...this.state,
    				formData: {
    					name: task.name,
    					project_id: task.project_id,
    					description: task.description !== null ? res.data.task.description : "",
    					estimated:  (task.estimated / 60),
    					status_id: task.status_id,
    					parent_id: task.parent_id,
    					parent_name: task.parent_name,
    					area_id: task.area_id,
    					parent: !!((task.parent_id !== null && task.parent_id !== 0)),
    					forced_to_log: task.forced_to_log || null,
    					assigned_to: task.assigned_to
    				},
    				newTaskFormData: {
    					name:  task.name ? `BUG FIXING - ${task.name}` : "",
    					description: task.description !== null ? res.data.task.description : "",
    					status_id: task.status_id,
    					project_id: task.project_id,
    					parent: true,
    					parent_id: task.id,
    					area_id: task.area_id,
    					assigned_to: task.assigned_to,
    					forced_to_log: true				
    				},
    				newTaskParent: dataToSelectOption(task.id,"id",task.name,"name"),
    				newTaskSelectedEmployee: dataToSelectOption(task.assigned_to,"id",task.assigned_name,"full_name"),
    				selectedEmployee: dataToSelectOption(task.assigned_to,"id",task.assigned_name,"full_name"),
    				selectedParentTask: dataToSelectOption(task.parent_id,"id", task.parent_name,"name"),
    				selectedProject: dataToSelectOption(task.project_id,"value", task.project_name,"label"),
    				selectedArea: dataToSelectOption(task.area_id,"value", task.area_name,"label"),
    				isLoadingTask: false,
    			});
    		}
    	}).catch((err) => {
    		this.setState({isLoadingTask: false});
    		HandleError(err);
    	});
    }
	
	handleNewTaskModal = () => {
		this.setState({
			...this.state,
			showNewTaskModal: true
		});
	}

	handleCloseModal = () => { this.setState({ showNewTaskModal: false });}

	handleAsyncSearch = (input = null, attribute, extra, callback) => {
		if (!input || !input.replace(/\s/g, "").length) {
		 callback(null, { complete: true });
		 return;
		}
		this.asyncCallback(input, attribute, extra, callback);
	}

	asyncCallback = debounce((input, attribute, extra, callback) => {
		this.searchService.searchByAttribute(attribute, input, extra).then((res) => {
			callback(null, {options: res.data , complete: true });
		}).catch((err) => {
			HandleError(err);
			callback(null, { complete: true });
		});
	}, 700);
    
	usersService = new AdminService(this,"users"); 
    projectsService = new ProjectsService(this,"?task=true");
	searchService = new SearchService(this);
	tasksService = new TasksService(this)

	render() {
    	const { 
    		isLoadingTask, isLoadingStatuses, isLoadingAreas, isUpdatingTask, 
    		formData, errors, areas, statuses, selectedEmployee, selectedParentTask,selectedProject, selectedArea, newTaskErrors,
		} = this.state;
		return (
    		<React.Fragment>
    			<Row>
					{isLoadingTask ? <LoadingSVG /> : 
						<form onSubmit={this.onSubmit}>
							<Col lg={6} md={12} sm={12}>
								<span className="column-title">Task details</span>		
								<FormGroup validationState={errors.name && "error"}>
									<ControlLabel>Name</ControlLabel>
									<FormControl type="text" name="name" placeholder="Enter task name" value={formData.name || ""} onChange={(e)=>this.onChange(e,"formData")}/>
									{errors.name && <InlineError text={errors.name} />}								                                
								</FormGroup>						
								<Row>
									<Col md={6}>
										<FormGroup validationState={errors.project_id && "error"}>
											<ControlLabel>Project</ControlLabel>	
											<Select
												onChange={(option) => { this.onProjectsSelectChange(option, "project_id"); }}
												name="project_id"
												placeholder="Choose project "
												value={selectedProject}
												options={[]}
												clearable={false}
												multi={false}
												disabled
											/>
											{errors.project_id && <InlineError text={errors.project_id} />}	
										</FormGroup>
									</Col>
									<Col md={6}>
										<FormGroup validationState={errors.area_id && "error"}>
											<ControlLabel>Area</ControlLabel>	
											<Select
												onChange={(option) => { this.onSelectChange(option, "area_id", "formData"); }}
												name="area_id"
												placeholder="Choose area"
												value={selectedArea}
												options={[]}
												isLoading={isLoadingAreas}
												disabled
												clearable={false}
												multi={false}
											/>
											{errors.area_id && <InlineError text={errors.area_id} />}	
										</FormGroup>
									</Col>
								</Row>
								<Row>
									<Col md={6}>
										<FormGroup validationState={errors.status_id && "error"}>
											<ControlLabel>Status</ControlLabel>	
											<Select
												onChange={(option) => { this.onSelectChange(option, "status_id", "selectedStatus", "formData"); }}
												name="status_id"
												placeholder="Choose task status"
												value={formData.status_id || ""}
												options={statuses}
												isLoading={isLoadingStatuses}
												clearable={false}
												multi={false}
											/>
											{errors.status_id && <InlineError text={errors.status_id} />}	
										</FormGroup>
									</Col>
									<Col md={6}>
										<FormGroup validationState={errors.estimated && "error"}>
											<ControlLabel>Estimation (Hours)</ControlLabel>                                  
											<FormControl  min="0" type="text" name="estimated" placeholder="Enter task estimation"  value={formData.estimated || ""} onChange={(e)=>this.onChange(e,"formData")}/>						
											{errors.estimated && <InlineError text={errors.estimated} />}								                                							
										</FormGroup>
									</Col>
								</Row>
								<FormGroup className="edit-placeholder" validationState={errors.assigned_to && "error"}>
									<ControlLabel>Assign to</ControlLabel>	
									<Select.Async
										onChange={(option) => { this.onEmployeeSelectChange(option, "selectedEmployee", "formData"); }}
										name="assigned_to"
										placeholder="Choose employee"
										value={selectedEmployee}
										labelKey="full_name"
										valueKey="id"
										loadOptions={(e,c) => this.handleAsyncSearch(e,"user","roles=2,4",c)}
										clearable={false}
										multi={false}
									/>
									{errors.assigned_to && <InlineError text={errors.assigned_to} />}
								</FormGroup>

								<FormGroup validationState={errors.forced_to_log && "error"}>
									<Checkbox name="forced_to_log" inline checked={this.state.formData.forced_to_log} onChange={(e)=>this.onCheckboxChange(e,"formData")}>
										Force user to log at this task 
									</Checkbox> 
									{errors.forced_to_log && <InlineError text={errors.forced_to_log} />}	
								</FormGroup> 

								<FormGroup>
									<Checkbox name="parent" inline checked={this.state.formData.parent} onChange={(e)=>this.onCheckboxChange(e,"formData")}>
                                        Choose task parent
									</Checkbox> 
								</FormGroup>

								{this.state.formData.parent && 
                                    <FormGroup className="edit-placeholder" validationState={errors.parent_id && "error"}>
                                    	<ControlLabel>Parent Task</ControlLabel>	
                                    	<Select.Async
                                    		onChange={(option) => { this.onParentSelectChange(option, "parent_id"); }}
                                    		name="parent_id"
                                    		placeholder="Choose parent task"
                                    		value={selectedParentTask}
                                    		labelKey="name"
                                    		valueKey="id"
                                    		loadOptions={(e,c) => this.handleAsyncSearch(e,"task",null,c)}
                                    		clearable={false}
                                    		multi={false}
                                    	/>
                                    	{errors.parent_id && <InlineError text={errors.parent_id} />}	
                                    </FormGroup>
								}

								<FormGroup validationState={errors.description && "error"}>
									<ControlLabel>Description</ControlLabel>                                  
									<FormControl componentClass="textarea" name="description" placeholder="Enter task description"  value={formData.description || ""} onChange={(e)=>this.onChange(e,"formData")}/>						
									{errors.description && <InlineError text={errors.description} />}								                                							
								</FormGroup>

								<Button className="btn-crud" bsStyle="primary" disabled={isUpdatingTask} type="submit">{isUpdatingTask? <LoaderInline width="20" height="20" color="#fff"/> :"Update"}</Button> 
								<Button className="btn-crud btn-bug" bsStyle="info" type="button" onClick={this.handleNewTaskModal}>Add bug fixing task</Button> 																										
							</Col>	
						</form>
					}					
    			</Row>
				<NewTaskModal
					disableParent
					isLoadingStatuse={isLoadingStatuses}
					saveTaskLoading={this.state.saveTaskLoading}
					showNewTaskModal={this.state.showNewTaskModal}
					newTaskFormData={this.state.newTaskFormData}
					newTaskErrors={newTaskErrors}
					newTaskSelectedEmployee={this.state.newTaskSelectedEmployee}
					selectedArea={selectedArea}
					selectedProject={selectedProject}
					statuses={this.state.statuses}
					onTaskCreateSubmit={this.onTaskCreateSubmit}
					onChange={this.onChange}
					onCheckboxChange={this.onCheckboxChange}
					onSelectChange={this.onSelectChange}
					onEmployeeSelectChange={this.onEmployeeSelectChange}
					newTaskParent={this.state.newTaskParent}
					handleCloseModal={this.handleCloseModal}
					handleAsyncSearch={this.handleAsyncSearch}
				/>
    		</React.Fragment>
    	);
	}
}
 
TaskEditForm.propTypes = {
	match: PropTypes.shape({
		params: PropTypes.shape({
			taskId: PropTypes.string.isRequired,
		}).isRequired,
	}).isRequired,
    
	history: PropTypes.shape({
		goBack: PropTypes.func.isRequired
	}).isRequired
};
export default TaskEditForm;


// WEBPACK FOOTER //
// ./src/components/forms/tasks/TaskEditForm.js